import { PriceContextSetter } from '@context/priceContext'
import { useContext } from 'react'

export function usePriceSetter() {
  return useContext(PriceContextSetter)
}
